import React from "react";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";
import { Esc as EscIcon } from "@dreamhub/designsystem/icons";
import { ArrowUp, ArrowDown, Enter } from "@dreamhub/designsystem/icons";

export const SearchFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div
      className="pr-4 pl-6 py-3 bg-surface-elevation1 border-t border-border-border1"
      data-test="global-search-footer"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center gap-1">
            <IconContainer size="sm" color="tertiary">
              <EscIcon />
            </IconContainer>
            <Text variant="smBodyTertiary">
              {t("globalSearch.searchFooter.close")}
            </Text>
          </div>
        </div>
        <div className="flex items-center space-x-4">
          <div className="flex items-center gap-1">
            <div className="flex items-center">
              <IconContainer size="sm" color="tertiary">
                <ArrowUp />
              </IconContainer>
              <IconContainer size="sm" color="tertiary">
                <ArrowDown />
              </IconContainer>
            </div>
            <Text variant="smBodyTertiary">
              {t("globalSearch.searchFooter.select")}
            </Text>
          </div>
          <div className="flex items-center gap-1">
            <IconContainer size="sm" color="tertiary" className="mt-[2px]">
              <Enter />
            </IconContainer>
            <Text variant="smBodyTertiary">
              {t("globalSearch.searchFooter.open")}
            </Text>
          </div>
        </div>
      </div>
    </div>
  );
};
